module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-dance.9b4cb5d0.png";